export default __webpack_public_path__ + "static/media/taormina.5841c268.png";